
function SdDateRangeCtrl(TranslationService, StoreService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();


    ctrl.$onInit = function () {
        ctrl.loaded = false;
        
    };

    ctrl.$onChanges = function (changes) {
        //console.log('sd-date-range.$onChanges', changes);
        
    };

    ctrl.options = {
        //customClass: getDayClass,
        //minDate: new Date(),
        //minDate: $scope.lastStartTime,
        datePickerMode: 'month',
        showWeeks: false
    };

    ctrl.selectOption = function (option, event) {
        //ctrl.ngModel = option.Key;
        //ctrl.value = option.Value;

        ctrl.ngModel = option;
        ctrl.value = option;


        //ctrl.mode = option.ContactName;
        //ctrl.contact = option;
    };

    ctrl.getValue = function () {
        if (ctrl.ngModel && ctrl.options) {
            var item = ctrl.options.find(function (p) {
                return p == ctrl.ngModel;
                //return p.Key == ctrl.ngModel;
            });
            if (item) {
                //return item.Value;
                return item;
            }
        }
        return '';
    };

    ctrl.ok = function () {
        // commit values
        ctrl.isOpen = false;
        ctrl.onOk();
    };

    ctrl.cancel = function () {
        //cancel values
        ctrl.isOpen = false;
    };
}

SdDateRangeCtrl.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdDateRange', {
    controller: SdDateRangeCtrl,
    bindings: {        
        Name: '=',
        label: '<',
        startDate: '=',
        endDate: '=',        
        hasEndDate: '<',
        canClear: '<',
        onOk: '&'
    },
    templateUrl: '/SPA/Components/sd-date-range.html' + seedWebApp.buildVersion
});